export type DistributionId = 'binomial' | 'geometric' | 'poisson' | 'hypergeometric';

export interface DistributionPreset {
  id: DistributionId;
  labelKey: `submode.named-distributions.${DistributionId}.label`;
  defaults: Record<string, number>;
}

export const DISTRIBUTION_PRESETS: readonly DistributionPreset[] = [
  {
    id: 'binomial',
    labelKey: 'submode.named-distributions.binomial.label',
    defaults: { n: 20, p: 0.4 },
  },
  {
    id: 'geometric',
    labelKey: 'submode.named-distributions.geometric.label',
    defaults: { p: 0.3 },
  },
  { id: 'poisson', labelKey: 'submode.named-distributions.poisson.label', defaults: { lambda: 3 } },
  {
    id: 'hypergeometric',
    labelKey: 'submode.named-distributions.hypergeometric.label',
    defaults: { N: 20, K: 7, n: 5 },
  },
];
